export const MIN_LICENSE_COUNT = 5;
export const MAX_LICENSE_COUNT = 125;
